import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../assets/css/admin/cc/CcHeader.css";
import { clearAdminStorage, getStoredAdminInfo } from "../AdminAuth";

function getLocalStorageValue(...keys) {
  for (const key of keys) {
    const value = localStorage.getItem(key);

    if (value && value.trim()) {
      return value.trim();
    }
  }

  return "";
}

function normalizePermissionLabel(value) {
  if (!value) return "";

  const name = String(value).trim().replace(/\s+/g, " ");

  if (!name) return "";

  if (name === "관리자") {
    return "관리자";
  }

  if (name.endsWith("관리자")) {
    return name;
  }

  if (name.endsWith("학생회")) {
    const unitName = name.replace(/학생회$/, "").trim();

    if (!unitName) {
      return "관리자";
    }

    return `${unitName} 관리자`;
  }

  return `${name} 관리자`;
}

function getPermissionLabel(adminInfo) {
  const storedPermissionName =
    adminInfo.permissionName ||
    adminInfo.roleName ||
    adminInfo.authorityName ||
    adminInfo.authorityGroup ||
    adminInfo.groupName ||
    getLocalStorageValue(
      "permissionName",
      "roleName",
      "authorityName",
      "authorityGroup",
      "groupName"
    );

  if (storedPermissionName) {
    return normalizePermissionLabel(storedPermissionName) || "관리자";
  }

  const fallbackName =
    adminInfo.headerName ||
    adminInfo.unitName ||
    adminInfo.adminName ||
    adminInfo.name ||
    adminInfo.userName ||
    adminInfo.adminId ||
    getLocalStorageValue(
      "headerName",
      "unitName",
      "adminName",
      "name",
      "userName",
      "adminId"
    ) ||
    "관리자";

  return normalizePermissionLabel(fallbackName) || "관리자";
}

export default function CcHeader() {
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;

    if (path.includes("/intro")) return "소개 관리";
    if (path.includes("/board")) return "조직별 관리";
    if (path.includes("/data")) return "자료실 관리";
    if (path.includes("/account")) return "내 계정 설정";

    return "관리자 페이지";
  };

  return (
    <header className="cc-header">
      <h2 className="cc-header-title">{getPageTitle()}</h2>
      <CcUserDropdown />
    </header>
  );
}

function CcUserDropdown() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const adminInfo = getStoredAdminInfo();

  const getUserLabel = () => {
    const permissionLabel = getPermissionLabel(adminInfo);

    if (permissionLabel.endsWith("님")) {
      return `안녕하세요, ${permissionLabel}`;
    }

    return `안녕하세요, ${permissionLabel}님`;
  };

  const handleAccountMove = () => {
    setOpen(false);
    navigate("/stdcounciladmin/adminhome/account");
  };

  const handleLogout = () => {
    clearAdminStorage();

    setOpen(false);

    navigate("/stdcounciladmin", {
      replace: true,
    });
  };

  return (
    <div className="cc-header-user-container">
      <button
        type="button"
        className={`cc-header-user ${open ? "is-open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="cc-header-user-label">{getUserLabel()}</span>
        <span className="cc-header-arrow" aria-hidden="true" />
      </button>

      {open && (
        <div className="cc-user-dropdown">
          <button
            type="button"
            className="cc-dropdown-item"
            onClick={handleAccountMove}
          >
            내 계정 설정
          </button>

          <button
            type="button"
            className="cc-dropdown-item"
            onClick={handleLogout}
          >
            로그아웃
          </button>
        </div>
      )}
    </div>
  );
}